import { englishMessages } from 'admin-on-rest';
import hebrewMessages from '../aor-language-hebrew';

import customHebrewMessages from './he';
import customEnglishMessages from './en';

export default {
    /*fr: { ...frenchMessages, ...customFrenchMessages },*/
    en: { ...englishMessages, ...customEnglishMessages },
    he: { ...hebrewMessages, ...customHebrewMessages },
};



// WEBPACK FOOTER //
// ./src/i18n/index.js